import React from "react";
import "../../styles/Solis.css";
const Solis = () => {
  return (
    <div className="solis-page">

      {/* HERO SECTION */}
      <section className="hero-section text-white d-flex align-items-center">
        <div className="container text-center">
          <h1 className="fw-bold">Solis</h1>
          <h4 className="mb-3">Hospital Room Management System</h4>
          <p className="lead">
            Smart, real-time digital solution for managing hospital rooms,
            patients, and doctor assignments efficiently.
          </p>
          
        </div>
      </section>

            <section className="launch-section py-5">
        <div className="container">
          <div className="launch-card text-center">

            <div className="launch-badge">
              🎉 Successfully Launched
            </div>

            <h2 className="section-title mt-4">
              Solis Hospital Room Management System
            </h2>

            <p className="launch-date">
              Officially launched on <strong>24th May 2026</strong>
            </p>

            <p className="launch-description">
              We are proud to announce the successful launch of Solis, a smart
              Hospital Room Management System designed to streamline room
              management, patient assignments, doctor coordination, queue
              announcements, and real-time display updates.
            </p>

            <div className="launch-contact">
              <h5>For More Information Contact</h5>

              <div className="d-flex justify-content-center gap-3 flex-wrap mt-3">
                <a href="tel:9964585585" className="btn btn-primary px-4">
                  <i className="bi bi-telephone-fill me-2"></i>
                  9964585585
                </a>

                <a
                  href="https://wa.me/919964585585"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-success px-4"
                >
                  <i className="bi bi-whatsapp me-2"></i>
                  WhatsApp
                </a>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* OVERVIEW */}
      <section className="py-5">
        <div className="container">
          <h2 className="section-title">Overview</h2>
          <p>
            Solis is a modern Hospital Room Management System designed to
            digitally manage hospital rooms, patient assignments, and doctor
            coordination in real time. It replaces manual processes with an
            automated, centralized platform ensuring accurate and instant
            communication across departments.
          </p>
        </div>
      </section>


      {/* WHY SOLIS */}
<section className="py-5 bg-light">
  <div className="container">

    <h2 className="section-title text-center mb-5">
      Why Solis?
    </h2>

    <div className="row justify-content-center mb-5">
      <div className="col-lg-10">
        <p className="lead text-center">
          At <strong>Polarsys</strong>, we believe that healthcare should be
          about healing, not waiting. The <strong>Solis Hospital Room & OPD
          Queue Management System</strong> is designed to eliminate the chaos
          of crowded waiting areas, reduce patient anxiety, and optimize
          clinical workflows through intelligent digital automation.
        </p>
      </div>
    </div>

    <div className="row g-4">

      <div className="col-md-6">
        <div className="feature-card h-100">
          <i className="bi bi-display-fill"></i>
          <h5>Real-Time OPD Queue Tracking</h5>
          <p>
            Live digital tokens, waiting status, and display screens keep
            patients informed, reduce perceived waiting time, and minimize
            front-desk congestion.
          </p>
        </div>
      </div>

      <div className="col-md-6">
        <div className="feature-card h-100">
          <i className="bi bi-hospital-fill"></i>
          <h5>Smart Room Allocation</h5>
          <p>
            Automatically updates room availability, patient assignments,
            admissions, discharges, and housekeeping workflows in real time.
          </p>
        </div>
      </div>

      <div className="col-md-6">
        <div className="feature-card h-100">
          <i className="bi bi-person-check-fill"></i>
          <h5>Seamless Doctor–Patient Flow</h5>
          <p>
            Doctors can instantly call the next patient with a single click,
            ensuring faster consultations and smoother OPD operations.
          </p>
        </div>
      </div>

      <div className="col-md-6">
        <div className="feature-card h-100">
          <i className="bi bi-graph-up-arrow"></i>
          <h5>Data-Driven Insights</h5>
                <p>
                  Analyze patient flow, peak hours, waiting times, and operational
                  bottlenecks to continuously improve hospital efficiency.
                </p>
              </div>
            </div>

          </div>

          <div className="text-center mt-5">
            <h4 className="fw-bold">
              Transform your healthcare facility into a calm, highly organized
              environment where patient satisfaction comes first.
            </h4>
          </div>

        </div>
      </section>

      {/* FEATURES */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="section-title text-center mb-4">Key Features</h2>

          <div className="row g-4">

            <div className="col-md-4">
              <div className="feature-card">
                <i className="bi bi-building"></i>
                <h5>Centralized Management</h5>
                <p>Manage all hospital rooms from a single dashboard.</p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="feature-card">
                <i className="bi bi-lightning"></i>
                <h5>Real-Time Updates</h5>
                <p>Instant updates on room displays using live sync.</p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="feature-card">
                <i className="bi bi-people"></i>
                <h5>Patient & Doctor Assignment</h5>
                <p>Quickly assign and update room details.And Queue Announcements </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="feature-card">
                <i className="bi bi-tv"></i>
                <h5>Automated Display</h5>
                <p>Information shown on TV screens or tablets.</p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="feature-card">
                <i className="bi bi-shield-lock"></i>
                <h5>Secure Access</h5>
                <p>JWT-based authentication ensures security.</p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="feature-card">
                <i className="bi bi-diagram-3"></i>
                <h5>Scalable Architecture</h5>
                <p>Supports multi-hospital environments.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="py-5">
        <div className="container">
          <h2 className="section-title text-center mb-4">How It Works</h2>

          <div className="row text-center g-4">
            {[
              "Admin logs into system",
              "Selects a room",
              "Assigns patient & doctor",
              "Data stored securely",
              "Real-time update triggered",
              "Display updates automatically"
            ].map((step, index) => (
              <div key={index} className="col-md-2 col-6">
                <div className="step-box">
                  <span>{index + 1}</span>
                  <p>{step}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-5 security-section">
      <div className="container">
        <h2 className="section-title text-center mb-5">Security</h2>

        <div className="row g-4">

          <div className="col-md-4 col-sm-6">
            <div className="security-card">
              <i className="bi bi-shield-lock-fill"></i>
              <h6>HTTPS Encryption</h6>
              <p>Secure communication using HTTPS protocols.</p>
            </div>
          </div>

          <div className="col-md-4 col-sm-6">
            <div className="security-card">
              <i className="bi bi-key-fill"></i>
              <h6>JWT Authentication</h6>
              <p>Token-based secure login and API access.</p>
            </div>
          </div>

          <div className="col-md-4 col-sm-6">
            <div className="security-card">
              <i className="bi bi-person-check-fill"></i>
              <h6>Role-Based Access</h6>
              <p>Controlled access for admins and staff.</p>
            </div>
          </div>

          <div className="col-md-4 col-sm-6">
            <div className="security-card">
              <i className="bi bi-diagram-3-fill"></i>
              <h6>Internal Network</h6>
              <p>Runs securely within hospital LAN.</p>
            </div>
          </div>

          <div className="col-md-4 col-sm-6">
            <div className="security-card">
              <i className="bi bi-file-earmark-lock-fill"></i>
              <h6>Compliance Ready</h6>
              <p>Designed with HIPAA & GDPR considerations.</p>
            </div>
          </div>

        </div>
      </div>
    </section>

{/* BENEFITS */}
<section className="py-5 bg-light">
  <div className="container">
    <h2 className="section-title text-center mb-5">Benefits</h2>

    <div className="row g-4">

      {/* Operational */}
      <div className="col-md-4">
        <div className="benefit-card">
          <h5><i className="bi bi-gear-fill me-2"></i>Operational</h5>
          <ul>
            <li>Eliminates manual updates</li>
            <li>Improves staff communication</li>
            <li>Reduces workload</li>
            <li>Ensures real-time accuracy</li>
          </ul>
        </div>
      </div>


      {/* Display System */}
      <div className="col-md-4">
        <div className="benefit-card highlight-card">
          <h5><i className="bi bi-tv-fill me-2"></i>Display System</h5>
          <ul>
            <li>Room number with patient & doctor info</li>
            <li>Scrolling information display</li>
            <li>Announcements & alerts</li>
            <li>Advertisement display support</li>
            <li>Queue Announcements</li>
          </ul>
        </div>
      </div>

      {/* Business */}
      <div className="col-md-4">
        <div className="benefit-card">
          <h5><i className="bi bi-briefcase-fill me-2"></i>Business</h5>
          <ul>
            <li>Scalable for large hospitals</li>
            <li>Supports multi-ward operations</li>
            <li>Future-ready for SaaS deployment</li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</section>

      {/* USE CASE */}
      <section className="py-5">
        <div className="container text-center">
          <h2 className="section-title mb-4">Use Case</h2>
          <p className="mb-4">Ideal for:</p>

          <div className="row justify-content-center g-4">

            <div className="col-md-3 col-6">
              <div className="use-card">
                <i className="bi bi-hospital"></i>
                <p>Hospitals</p>
              </div>
            </div>

            <div className="col-md-3 col-6">
              <div className="use-card">
                <i className="bi bi-heart-pulse"></i>
                <p>Clinics</p>
              </div>
            </div>

            <div className="col-md-3 col-6">
              <div className="use-card">
                <i className="bi bi-building"></i>
                <p>Multi-specialty Centers</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* WHY CHOOSE SOLIS */}
      <section className="py-5 why-section text-white">
        <div className="container text-center">
          <h2 className="section-title mb-4 text-white">Why Choose Solis?</h2>
          <p className="lead mx-auto" style={{ maxWidth: "700px" }}>
            Solis transforms traditional hospital room management into a smart,
            automated, and real-time digital system, improving both operational
            efficiency and patient experience.
          </p>
        </div>
      </section>

      {/* ABOUT POLARSYS */}
      <section className="py-5">
        <div className="container">

          <h2 className="section-title text-center mb-5">
            About Polarsys
          </h2>

          <div className="row justify-content-center">
            <div className="col-lg-10">

              <p className="lead text-center mb-5">
                <strong>Polarsys</strong> is a forward-thinking technology solutions
                provider committed to engineering impactful, enterprise-grade
                software and hardware systems. We bridge the gap between grassroots
                innovation and international standards by delivering smart
                automation, healthcare technology, IoT infrastructure, and
                enterprise digital solutions.
              </p>

              <div className="row g-4">

                <div className="col-md-4">
                  <div className="benefit-card h-100 text-center">
                    <i className="bi bi-globe2 fs-1 text-primary"></i>
                    <h5 className="mt-3">Our Vision</h5>
                    <p>
                      <strong>Made in Rural, Driven to the World.</strong>
                      We proudly build globally competitive technology products
                      engineered by talented professionals from rural innovation
                      hubs.
                    </p>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="benefit-card h-100 text-center">
                    <i className="bi bi-lightbulb-fill fs-1 text-warning"></i>
                    <h5 className="mt-3">Innovation</h5>
                    <p>
                      Every solution is designed to empower organizations,
                      strengthen communities, and create measurable business impact
                      through intelligent automation.
                    </p>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="benefit-card h-100 text-center">
                    <i className="bi bi-award-fill fs-1 text-success"></i>
                    <h5 className="mt-3">Global Quality</h5>
                    <p>
                      Built on secure, scalable, enterprise-grade architecture to
                      meet the demanding requirements of hospitals and organizations
                      worldwide.
                    </p>
                  </div>
                </div>

              </div>

              <div className="mt-5">

                <h4 className="text-center mb-4">
                  Core Expertise
                </h4>

                <div className="row g-3">

                  <div className="col-md-3">
                    <div className="feature-card text-center">
                      <i className="bi bi-heart-pulse-fill"></i>
                      <h6 className="mt-3">Healthcare Informatics</h6>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="feature-card text-center">
                      <i className="bi bi-diagram-3-fill"></i>
                      <h6 className="mt-3">Smart Queue Management</h6>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="feature-card text-center">
                      <i className="bi bi-cpu-fill"></i>
                      <h6 className="mt-3">Enterprise IoT</h6>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="feature-card text-center">
                      <i className="bi bi-gear-fill"></i>
                      <h6 className="mt-3">Industrial Automation</h6>
                    </div>
                  </div>

                </div>

              </div>

            </div>
          </div>

        </div>
      </section>

      {/* CTA */}
        <section className="py-5 text-center cta-section text-white">
        <div className="container">
            <h2>Transform Your Hospital Digitally</h2>
            <p>Upgrade to Solis for smarter, real-time management.</p>

            <div className="d-flex justify-content-center gap-3 flex-wrap mt-3">
            
            {/* Call Button */}
            <a href="tel:9964585585" className="btn btn-light px-4 py-2">
                <i className="bi bi-telephone-fill me-2"></i>
                Call: 9964585585
            </a>

            {/* WhatsApp Button */}
            <a
                href="https://wa.me/919964585585"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-success px-4 py-2"
            >
                <i className="bi bi-whatsapp me-2"></i>
                WhatsApp
            </a>

            </div>
        </div>
        </section>

    </div>
  );
};

export default Solis;